import { useState } from 'react';
import { List, useListContext, CreateButton, TopToolbar, useRedirect, useNotify, useRefresh } from 'react-admin';
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Button } from '@mui/material';
import { tbl, btn, badgeStyle, clickableA11y, WEBSITE_PUBLICATION_STATE } from '../styles/ds';
import EmptyState from '../components/EmptyState';
import { websiteRequest } from './websiteApi';

const Toolbar = () => (
  <TopToolbar><CreateButton label="קטגוריית אתר חדשה" sx={btn.create} /></TopToolbar>
);

/** Publish/unpublish one category (explicit admin action; carries its version). */
export const CategoryPublicationButton = ({ category, onDone }) => {
  const notify = useNotify();
  const [busy, setBusy] = useState(false);
  const isPublished = category.publication_state === 'published';
  const toggle = async e => {
    e.stopPropagation();
    setBusy(true);
    try {
      await websiteRequest(`/website_categories/${category.id}/publication`, 'POST',
        { action: isPublished ? 'unpublish' : 'publish', version: category.version });
      notify(isPublished ? 'הקטגוריה הוסרה מפרסום' : 'הקטגוריה פורסמה', { type: 'success' });
      onDone();
    } catch (err) { notify(err.message, { type: 'error' }); }
    finally { setBusy(false); }
  };
  return (
    <Button size="small" variant="outlined" disabled={busy} onClick={toggle} sx={isPublished ? btn.cancel : btn.gold}>
      {isPublished ? 'הסר מפרסום' : 'פרסם'}
    </Button>
  );
};

const CategoryTable = () => {
  const { data = [], isLoading } = useListContext();
  const redirect = useRedirect();
  const refresh = useRefresh();
  if (isLoading) return null;
  if (!data.length) {
    return <EmptyState title="אין עדיין קטגוריות אתר" subtitle="קטגוריה מקבצת מוצרי אתר להצגה ללקוחות" />;
  }
  return (
    <TableContainer component={Box} sx={{ ...tbl.container, border: '1px solid rgba(13,29,62,0.06)' }}>
      <Box className="crm-table-scroll" data-mobile-scroll tabIndex={0} role="region" aria-label="טבלה נגללת"><Table>
        <TableHead><TableRow>
          <TableCell>שם (אנגלית)</TableCell>
          <TableCell>כתובת (slug)</TableCell>
          <TableCell align="center">סדר</TableCell>
          <TableCell align="center">מוצרי מקור ב-CRM</TableCell>
          <TableCell align="center">מצב</TableCell>
          <TableCell align="center">פעולה</TableCell>
        </TableRow></TableHead>
        <TableBody>
          {data.map((c, i) => (
            <TableRow key={c.id} onClick={() => redirect('edit', 'website_categories', c.id)}
              {...clickableA11y(() => redirect('edit', 'website_categories', c.id), { ariaLabel: `עריכת קטגוריה ${c.name_en}` })}
              sx={tbl.bodyRow(i)}>
              <TableCell><Typography fontWeight={600} fontSize={14} dir="ltr" textAlign="right">{c.name_en}</Typography></TableCell>
              <TableCell><Typography fontSize={13} color="text.secondary" dir="ltr" textAlign="right">{c.slug}</Typography></TableCell>
              <TableCell align="center">{c.sort_position}</TableCell>
              <TableCell align="center">{c.crm_product_ids?.length || 0}</TableCell>
              <TableCell align="center"><span style={badgeStyle(WEBSITE_PUBLICATION_STATE, c.publication_state)}>{WEBSITE_PUBLICATION_STATE[c.publication_state]?.label}</span></TableCell>
              <TableCell align="center"><CategoryPublicationButton category={c} onDone={refresh} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table></Box>
    </TableContainer>
  );
};

const WebsiteCategoryList = () => (
  <List className="crm-mobile-list crm-inline-list" sort={{ field: 'sort_position', order: 'ASC' }} perPage={1000}
    pagination={false} storeKey={false} actions={<Toolbar />} title="קטגוריות אתר" sx={tbl.listSx}>
    <CategoryTable />
  </List>
);
export default WebsiteCategoryList;
